import '../scss/style.scss';

console.log('Parcel is working. Hurray!');